import type { AnalyticsAdapter, CapturedEvent } from "./types";

/**
 * Mock analytics adapter for testing.
 *
 * Records all captured events for assertion in tests.
 */
export class MockAnalyticsAdapter implements AnalyticsAdapter {
  private events: CapturedEvent[] = [];
  private distinctId: string | null = null;

  identify(distinctId: string): void {
    this.distinctId = distinctId;
  }

  capture(event: string, properties?: Record<string, unknown>): void {
    this.events.push({
      event,
      distinct_id: this.distinctId,
      properties,
      timestamp: Date.now(),
    });
  }

  isInitialized(): boolean {
    return true;
  }

  // Test helper methods

  /**
   * Get all captured events.
   */
  getEvents(): CapturedEvent[] {
    return [...this.events];
  }

  /**
   * Get events by name.
   */
  getEventsByName(eventName: string): CapturedEvent[] {
    return this.events.filter((e) => e.event === eventName);
  }

  /**
   * Clear all captured events.
   */
  clear(): void {
    this.events = [];
  }
}
